import React from 'react';
import { useStore } from '../../../../../stores/root';

// assets
import { faCheck } from '@fortawesome/pro-light-svg-icons';

// services
import TrucksService from '../../../../../services/data/trucks';

// props
import { ITruckResourceShort } from '../../../../../props/data/trucks';

// components
import { DefaultButton, Panel, PanelType, PrimaryButton, Spinner, SpinnerSize, Stack } from '@fluentui/react';
import Label from '../../../../typography/label';
import Text from '../../../../typography/text';
import Tag from '../../../../uiframeworks/tag';

interface IDeleteTruckFormProps {
    truck: ITruckResourceShort;
    onDismissed(refresh?: boolean): void;
}

const DeleteTruckForm: React.FC<IDeleteTruckFormProps> = (props: IDeleteTruckFormProps) => {
    const { banner } = useStore();
    const [submitting, setSubmitting] = React.useState<boolean>(false);

    const _onSubmit = async () => {
        try {
            setSubmitting(true);
            await TrucksService.delete(props.truck.id);

            banner.add({
                key: 'delete_truck_success',
                variant: 'success',
                icon: faCheck,
                text: `Truck "${props.truck.name}" deleted successfully`
            });
            props.onDismissed(true);
        } catch (e) {
            setSubmitting(false);
        }
    }

    return <Panel headerText={"Delete Truck"}
        isOpen={true}
        type={PanelType.medium}
        onDismiss={() => props.onDismissed(false)}
        isFooterAtBottom={true}
        onRenderFooterContent={() => {
            return <Stack horizontal tokens={{ childrenGap: 10 }}>
                {
                    !submitting ? (
                        <>
                            <PrimaryButton text={"Delete"} onClick={_onSubmit} />
                            <DefaultButton text={"Cancel"} onClick={() => { props.onDismissed(false) }} />
                        </>
                    ) : null
                }
                {submitting ? <Spinner size={SpinnerSize.medium} labelPosition={"right"} label={"Deleting user ..."} /> : null}
            </Stack>;
        }}>
        <Stack tokens={{ childrenGap: 15 }} styles={{ root: { marginTop: 20 } }}>
            <Text>Are you sure you want to delete truck with details below?</Text>
            <Stack.Item>
                <Label>Name</Label>
                <Text>{props.truck.name}</Text>
            </Stack.Item>
            <Stack.Item>
                <Label>Registration Number</Label>
                <Text>{props.truck.registrationNumber}</Text>
            </Stack.Item>
            <Stack.Item>
                <Label>Vendor</Label>
                <Stack horizontal><Tag text={props.truck.vendor.name} /></Stack>
            </Stack.Item>
        </Stack>
    </Panel>
};

export default DeleteTruckForm;
